export const environment = {
    API_URL: 'https://api.murmures-nature.fr',
    API_TOKEN: 'cc8da5beb061817a7d2399f07a16596ae5371c890c552f0431b4b1850562872ac42e702fb8b7946935f9be24c18d8b254177660169dcc7d1addab1182eabc5331946024aa92045eddb4d376a88d9b3be981dd3b93102a312fc65448622de19266bb2ac3f831c0e0b636bb80bd12cefd6252bf1109bac39274235835c3456b2d7',
    EXPRESS_SERVER_PORT: 4001
};
